import ComponentLayout from "../../../../src/layouts/component-layout";
import { Label } from '@primer/react-brand';
import { Box as Container } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  Label,
  Container,
  PropTableValues,
  React
};